// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NZ35","title":"styles_title__3qjtC"};